import { getScriptNonce } from './getScriptNonce'

export type AddScriptOptions = {
  src: string
  id?: string
  async?: boolean
  defer?: boolean
  type?: string
  attributes?: Record<string, string>
}

/**
 * Adds a script tag to the document head if it does not already exist.
 * Checks by `id` (if provided) or `src`.
 * Returns the script element (existing or newly created).
 */
export function addScriptToPage(options: AddScriptOptions): HTMLScriptElement {
  const {
    src,
    id,
    async = true,
    defer = false,
    type = 'text/javascript',
    attributes = {}
  } = options
  let script: HTMLScriptElement | null = null

  if (id) {
    script = document.getElementById(id) as HTMLScriptElement | null
    if (script) return script
  }

  // Check for existing script by src
  const scripts = document.getElementsByTagName('script')
  for (let i = 0; i < scripts.length; i++) {
    const element = scripts[i] as HTMLScriptElement
    if (element.src === src) {
      return element
    }
  }

  script = document.createElement('script')
  script.src = src
  script.async = async
  script.defer = defer
  script.type = type
  if (id) script.id = id
  // Always set nonce
  const nonce = getScriptNonce()
  if (nonce) script.nonce = nonce
  for (const key in attributes) {
    if (Object.prototype.hasOwnProperty.call(attributes, key)) {
      script.setAttribute(key, attributes[key])
    }
  }
  document.head.appendChild(script)
  return script
}
